module.exports = __webpack_public_path__ + "static/media/stijn-bessem-testimonials-bob@2x.19132d68.jpg";